import React from "react";

import { Card, CardContent, CardActions, Typography } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";

import { ResultProps } from "./types";
import useStyles from "./styles";

const Result = ({ status, message, actions }: ResultProps) => {
  const styles = useStyles();

  const getIcon = () => {
    switch (status) {
      case "success":
        return (
          <div className={styles.successIcon}>
            <CheckCircleIcon fontSize="large" />
          </div>
        );
      case "error":
        return (
          <div>
            <ErrorIcon fontSize="large" color="error" />
          </div>
        );
      case "information":
        return (
          <div>
            <InfoIcon fontSize="large" color="primary" />
          </div>
        );
    }
  };

  return (
    <Card>
      <CardContent>
        <Typography>
          <div className={styles.content}>
            {getIcon()}

            {message && <p className={styles.message}>{message}</p>}
          </div>
        </Typography>
      </CardContent>

      <CardActions className={styles.actions}>
        <Typography>{actions && <div>{actions}</div>}</Typography>
      </CardActions>
    </Card>
  );
};

export default Result;
